import * as Yup from "yup";
import dayjs from "dayjs";
export const empAllowanceCreationValidation = Yup.object().shape({
  companyCode: Yup.number()
    .min(1, "Company code required")
    .required("Description is required"),
  code: Yup.number()
    .typeError("Please select addition")
    .required("Please select addition"),
  employeeCode: Yup.number()
    .transform((value, originalValue) =>
      isNaN(value) || originalValue === undefined ? 0 : value,
    )
    .default(0),
  departmentCode: Yup.number()
    .transform((value, originalValue) =>
      isNaN(value) || originalValue === undefined ? 0 : value,
    )
    .default(0),
  description: Yup.string().required("Description is required"),
  haveCPF: Yup.boolean().required("Please select haveCPF"),
  isTaxPayable: Yup.boolean().required("Please select isTaxPayable"),
  amount: Yup.number()
    .min(0, "Amount code required")
    .typeError("Amount is required")
    .required("Amount is required"),
  effectiveDateFrom: Yup.string().required("Select Effective Date"),
  // effectiveDateTo: Yup.string().required("Select End Date"),
  effectiveDateTo: Yup.string()
    .required("Select Effective To Date")
    .test(
      "is-after-effectiveDateFrom",
      "Effective To Date must be after Effective From Date",
      function (value) {
        const { effectiveDateFrom } = this.parent;
        return value && effectiveDateFrom
          ? dayjs(value) //.isAfter(dayjs(effectiveDateFrom))
          : true;
      },
    )
    .test(
      "is-not-before-yesterday",
      "Effective To Date cannot be in the past",
      function (value) {
        return value
          ? dayjs(value) //.isAfter(dayjs().subtract(1, "day").endOf("day"))
          : true;
      },
    ),

  isActive: Yup.boolean().required("Please select active status"),
});

export const empDeductionCreationValidation = Yup.object().shape({
  companyCode: Yup.number()
    .min(1, "Company code required")
    .required("Description is required"),
  code: Yup.number()
    .typeError("Please select addition")
    .required("Please select addition"),
  employeeCode: Yup.number()
    .transform((value, originalValue) =>
      isNaN(value) || originalValue === undefined ? 0 : value,
    )
    .default(0),
  // departmentCode: Yup.number() || 0,
  departmentCode: Yup.number()
    .transform((value, originalValue) =>
      isNaN(value) || originalValue === undefined ? 0 : value,
    )
    .default(0),
  description: Yup.string().required("Description is required"),
  haveCPF: Yup.boolean().required("Please select haveCPF"),
  // isTaxPayable: Yup.boolean().required("Please select isTaxPayable"),
  amount: Yup.number()
    .min(0, "Amount code required")
    .typeError("Amount is required")
    .required("Amount is required"),
  effectiveDateFrom: Yup.string().required("Select Effective Date"),
  // effectiveDateTo: Yup.string().required("Select End Date"),
  effectiveDateTo: Yup.string()
    .required("Select Effective To Date")
    .test(
      "is-after-effectiveDateFrom",
      "Effective To Date must be after Effective From Date",
      function (value) {
        const { effectiveDateFrom } = this.parent;
        return value && effectiveDateFrom
          ? dayjs(value).isAfter(dayjs(effectiveDateFrom))
          : true;
      },
    )
    .test(
      "is-not-before-yesterday",
      "Effective To Date cannot be in the past",
      function (value) {
        return value
          ? dayjs(value).isAfter(dayjs().subtract(1, "day").endOf("day"))
          : true;
      },
    ),

  isActive: Yup.boolean().required("Please select active status"),
});

export const empAllowanceDeductionValidation = Yup.object().shape({
  companyCode: Yup.number()
    .min(1, "Company code required")
    .required("Description is required"),
  code: Yup.number()
    .typeError("Please select addition")
    .required("Please select addition"),
  allowanceCode: Yup.number(),
  employeeCode: Yup.array()
    .of(
      Yup.number()
        .typeError("Employee code must be a number")
        .min(1, "Employee code must be a positive number")
        .required("Employee code is required"),
    )
    .required("Employee code is required")
    .test(
      "hasAtLeastOneElement",
      "Employee code must have at least one element",
      (values) => values && values.length > 0,
    ),
  departmentCode: Yup.number()
    .transform((value, originalValue) =>
      isNaN(value) || originalValue === undefined ? 0 : value,
    )
    .default(0),
  description: Yup.string().required("Description is required"),
  haveCPF: Yup.boolean().required("Please select haveCPF"),
  isTaxPayable: Yup.boolean().required("Please select isTaxPayable"),
  amount: Yup.number()
    .min(0, "Amount code required")
    .typeError("Amount is required")
    .required("Amount is required"),
  // effectiveDateFrom: Yup.string().required("Select Effective Date"),
  // effectiveDateTo: Yup.string().required("Select End Date"),
  // effectiveDateFrom: Yup.string().when("isTemporary", {
  //   is: (val) => val === true,
  //   then: (schema) => schema.required("Select Effective From Date"),
  //   otherwise: (schema) => schema.notRequired().nullable(),
  // }),
  effectiveDateFrom: Yup.string()
    .nullable()
    .when("isTemporary", {
      is: true,
      then: (schema) => schema.required("Select Effective From Date"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

  effectiveDateTo: Yup.string()
    .nullable()
    .when("isTemporary", {
      is: (val) => val === true,
      then: (schema) =>
        schema
          .required("Select Effective To Date")
          .test(
            "is-after-effectiveDateFrom",
            "Effective To Date must be after Effective From Date",
            function (value) {
              const { effectiveDateFrom } = this.parent;
              return value && effectiveDateFrom
                ? dayjs(value).isSame(dayjs(effectiveDateFrom)) ||
                    dayjs(value).isAfter(dayjs(effectiveDateFrom))
                : true;
            },
          ),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

  // .test(
  //   "is-not-before-yesterday",
  //   "Effective To Date cannot be in the past",
  //   function (value) {
  //     return value
  //       ? dayjs(value).isAfter(dayjs().subtract(1, "day").endOf("day"))
  //       : true;
  //   }
  // ),

  isActive: Yup.boolean().required("Please select active status"),
  isTemporary: Yup.boolean().required("Please select is temporary or not"),
  projectCode: Yup.string(), //required("Description is required"),
});

export const empAllowanceDeductionUpdateValidation = Yup.object().shape({
  companyCode: Yup.number()
    .min(1, "Company code required")
    .required("Description is required"),
  code: Yup.number()
    .typeError("Please select addition")
    .required("Please select addition"),
  allowanceCode: Yup.number(),
  employeeCode: Yup.number()
    .typeError("Employee code must be a number")
    .min(1, "Employee code must be a positive number")
    .required("Employee code is required"),
  departmentCode: Yup.number()
    .transform((value, originalValue) =>
      isNaN(value) || originalValue === undefined ? 0 : value,
    )
    .default(0),
  description: Yup.string().required("Description is required"),
  haveCPF: Yup.boolean().required("Please select haveCPF"),
  isTaxPayable: Yup.boolean().default(false).nullable(), //.required("Please select isTaxPayable"),
  amount: Yup.number()
    .min(0, "Amount code required")
    .typeError("Amount is required")
    .required("Amount is required"),
  // effectiveDateFrom: Yup.string().required("Select Effective Date"),
  // effectiveDateTo: Yup.string().required("Select End Date"),
  // effectiveDateFrom: Yup.string().when("isTemporary", {
  //   is: (val) => val === true,
  //   then: (schema) => schema.required("Select Effective From Date"),
  //   otherwise: (schema) => schema.notRequired().nullable(),
  // }),
  effectiveDateFrom: Yup.string()
    .nullable()
    .when("isTemporary", {
      is: true,
      then: (schema) => schema.required("Select Effective From Date"),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),

  effectiveDateTo: Yup.string()
    .nullable()
    .when("isTemporary", {
      is: (val) => val === true,
      then: (schema) =>
        schema
          .required("Select Effective To Date")
          .test(
            "is-after-effectiveDateFrom",
            "Effective To Date must be after Effective From Date",
            function (value) {
              const { effectiveDateFrom } = this.parent;
              return value && effectiveDateFrom
                ? dayjs(value).isSame(dayjs(effectiveDateFrom)) ||
                    dayjs(value).isAfter(dayjs(effectiveDateFrom))
                : true;
            },
          ),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),

  // .test(
  //   "is-not-before-yesterday",
  //   "Effective To Date cannot be in the past",
  //   function (value) {
  //     return value
  //       ? dayjs(value).isAfter(dayjs().subtract(1, "day").endOf("day"))
  //       : true;
  //   }
  // ),

  isActive: Yup.boolean().required("Please select active status"),
  isTemporary: Yup.boolean().required("Please select is temporary or not"),
  projectCode: Yup.string().nullable(), //required("Description is required"),
});

export const importEmpAllowanceDeductionValidation = Yup.object().shape({
  companyCode: Yup.number()
    .min(1, "Company code required")
    .required("Description is required"),
  adjType: Yup.number()
    .typeError("Adjustment Type is required")
    .required("Adjustment Type select addition"),
  adjName: Yup.string().required("Description is required"),
  employeeCode: Yup.number().default(0),
  uniqueId: Yup.string().required("Employee Code is required"),
  // .min(1, "Please Select Employee")
  // .required("Employee code is required"),
  departmentCode: Yup.string().default("0"),
  locationCode: Yup.string().required("location is required"),
  isActive: Yup.boolean().default(true),
  isTemporary: Yup.boolean().default(true),
  amount: Yup.number()
    .min(0, "Amount code required")
    .typeError("Amount is required")
    .required("Amount is required"),
  effectiveDateFrom: Yup.string().required("Select Effective Date"),
  effectiveDateTo: Yup.string().required("Select Effective To Date"),
});

const payrollSchema = Yup.object().shape({
  companyCode: Yup.number().required("Company code is required"),
  locationCode: Yup.string().required("Location code is required"),
  refNo: Yup.number().required("Reference number is required"),
  employeeCode: Yup.number().required("Employee code is required"),
  icno: Yup.string().nullable(),
  processDateStr: Yup.string().required("Process date is required"),
  procesMonth: Yup.number()
    .min(1)
    .max(12)
    .required("Process month is required"),
  processYear: Yup.number().min(1900).required("Process year is required"),

  paymentCode: Yup.number().required("Payment code is required"),
  departmentCode: Yup.number().required("Department code is required"),

  monthlySalary: Yup.number().min(0).required("Monthly salary is required"),
  basicSalary: Yup.number().min(0).required("Basic salary is required"),
  grossSalary: Yup.number().min(0).required("Gross salary is required"),

  addition: Yup.number().min(0).required("Addition is required"),
  deduction: Yup.number().min(0).required("Deduction is required"),

  totalCpf: Yup.number().min(0).required("Total CPF is required"),
  employeeCpf: Yup.number().min(0).required("Employee CPF is required"),
  employerCpf: Yup.number().min(0).required("Employer CPF is required"),

  leaveTakenInDays: Yup.number()
    .min(0)
    .required("Leave taken in days is required"),
  leaveSalaryAmount: Yup.number()
    .min(0)
    .required("Leave salary amount is required"),
  netPay: Yup.number().min(0).required("Net pay is required"),

  contributionCode: Yup.number(), // .required(),
  agencyAmount: Yup.number(), //.min(0).required(),
  sdlAmount: Yup.number(), //.min(0).required(),

  noOfDaysInMonth: Yup.number()
    .min(0)
    .required("Number of days in month is required"),
  noOfWorkingDays: Yup.number()
    .min(0)
    .required("Number of working days is required"),

  hourlySalary: Yup.number().min(0).required("Hourly salary is required"),
  additionalHours: Yup.number().min(0).required("Additional hours is required"),
  deductionHours: Yup.number().min(0).required("Deduction hours is required"),

  otHourlySalary: Yup.number().min(0).required("OT hourly salary is required"),
  noOfOTWorkingDays: Yup.number()
    .min(0)
    .required("Number of OT working days is required"),
  otDaySalary: Yup.number().min(0).required("OT day salary is required"),

  payrollValue: Yup.number().min(0).required("Payroll value is required"),
  createUser: Yup.string(), //.required("Create user is required"),

  extraorlessHourAmount: Yup.number()
    .min(0)
    .required("Extra or less hour amount is required"),
  daySalary: Yup.number().min(0).required("Day salary is required"),

  publicHolidayHours: Yup.number()
    .min(0)
    .required("Public holiday hours are required"),
  publicHolidayHoursSalary: Yup.number()
    .min(0)
    .required("Public holiday hours salary is required"),

  payrollDetail: Yup.array()
    .of(Yup.object())
    .required("Payroll detail is required"),

  waitingTime: Yup.number().min(0).required("Waiting time is required"),
  waitingTimeSalary: Yup.number()
    .min(0)
    .required("Waiting time salary is required"),
  advancePayment: Yup.number().min(0).required(" Advance payment is required"),

  normalWorkingHoursInMonth: Yup.number()
    .min(0)
    .required("Normal working hours in month is required"),
  normalWorkingHoursSalary: Yup.number()
    .min(0)
    .required("Normal working hours salary is required"),

  oT1Hours: Yup.number().min(0).required("OT1 hours are required"),
  oT1HourlySalary: Yup.number()
    .min(0)
    .required("OT1 hourly salary is required"),
  oT2Hours: Yup.number().min(0).required("OT2 hours are required"),
  oT2HourlySalary: Yup.number()
    .min(0)
    .required("OT2 hourly salary is required"),

  extraHours: Yup.number().min(0).required("Extra hours are required"),
  extraHoursSalary: Yup.number()
    .min(0)
    .required("Extra hours salary is required"),

  publicHolidayOTHours: Yup.number()
    .min(0)
    .required("Public holiday OT hours are required"),
  publicHolidayOTHoursSalary: Yup.number()
    .min(0)
    .required("Public holiday OT hours salary is required"),
});

export const payrollStagingValidation = Yup.array().of(payrollSchema);

export const bankFileValidation = Yup.object().shape({
  // companyCode: Yup.number()
  //   .min(1, "Company code required")
  //   .required("Company code required"),
  // locationCode: Yup.string().required("Location code is required"),
  payDate: Yup.string().required("Pay date is required"),
  organisationId: Yup.string().required("Organisation ID is required"),
  organisationName: Yup.string().required("Organisation name is required"),
  accountNumber: Yup.string().required("Account number is required"),
  // bankName: Yup.string().required("Bank name is required"),
  // isActive: Yup.boolean().required("Please select active status"),
});

export const salaryUpdateReGenerateValidation = Yup.object().shape({
  companyCode: Yup.number().required("Company code is required"),
  locationCode: Yup.string().required("Location code is required"),
  month: Yup.string()
    .transform((value) => value.toString())
    .required("Payroll month is required"),
  year: Yup.string()
    .transform((value) => value.toString())
    .required("Payroll year is required"),
  userCode: Yup.string()
    .typeError("User code is required as string")
    .required("User code is required"),
  salaryType: Yup.string().required("Salary type is required"),
  basicSalary: Yup.number()
    .min(1)
    .typeError("Basic salary must be a positive number")
    .required("Basic salary is required"),
  employeeCode: Yup.number()
    .typeError("Employee code is required")
    .required("Employee code is required"),
});

export const updatePaymentDateValidation = Yup.object().shape({
  companyCode: Yup.number().required("Company code is required"),
  paymentDate: Yup.string().required("Payment date is required"),
  refNo: Yup.array()
    .of(
      Yup.number()
        .min(1)
        .typeError("Reference number must be a positive number")
        .required("Reference number is required"),
    )
    .required("Reference number is required"),
});
